<template>
  <b-form-group
    label="Tutar Aralığı"
    label-for="min_amount"
  >
    <b-input-group>
      <b-form-input
        id="min_amount"
        v-model="filterParams.min_amount"
        placeholder="Minimum Tutar"
        class="border-right-0"
      />
      <b-input-group-addon is-text>
        -
      </b-input-group-addon>
      <b-form-input
        id="max_amount"
        v-model="filterParams.max_amount"
        placeholder="Maximum Tutar"
      />
    </b-input-group>
  </b-form-group>
</template>
<script>
import {
  BFormGroup, BInputGroup, BInputGroupAddon, BFormInput,
} from 'bootstrap-vue'

export default {
  name: 'DonateDates',
  components: {
    BInputGroup,
    BFormGroup,
    BInputGroupAddon,
    BFormInput,
  },
  computed: {
    filterParams() {
      return this.$store.getters['accountActivities/filterParams']
    },
  },
}
</script>
